import React, { useState, useEffect } from "react";
import { DatePicker, Input, Select, Switch } from "antd";
import moment from "moment";
import { ErrorToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import useUserData from "../../../../../hooks/useUserData";
import UnitWithInput from "../../../../../components/UnitWithInput";
import {
  pressureUnits,
  temperatureUnits,
  volumeUnits,
} from "../../../../../Data/data";

// Map parameter names to labels and unit options
const parameterConfig = {
  uvintensity: { label: "UV Intensity", unitList: [] },
  uvtransmittance: { label: "UV Transmittance (UVT)", unitList: [] },
  flowrate: { label: "Flow Rate", unitList: volumeUnits },
  lamphours: { label: "Lamp Hours", unitList: [] },
  lampstatus: { label: "Lamp Status", unitList: [] },
  ballastpumpstatus: { label: "Ballast Pump Status", unitList: [] },
  inletoutletpressure: {
    label: "Inlet/Outlet Pressure",
    unitList: pressureUnits,
  },
  temperature: { label: "Temperature", unitList: temperatureUnits },
  operationballastingdeballasting: {
    label: "Operation (Ballasting/Deballasting)",
    unitList: [],
    dropdownOptions: ["Ballasting", "Deballasting"],
  },
  operationhours: { label: "Operation Hours", unitList: [] },
  totaloperationhours: { label: "Total Operation Hours", unitList: [] },
};

export const BWTSCargoMachinCom = ({ eng_log_basic_id, _items }) => {
  const user = useUserData();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    logDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    parameters: {},
    otherParams: {},
  });
  const [checked, setChecked] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  useEffect(() => {
    // Initialize parameters from _items.selected_parameters
    const initialParameters = (_items?.selected_parameters || []).reduce(
      (acc, param) => {
        if (parameterConfig[param]) {
          acc[param] = {
            value: "",
            unit: parameterConfig[param].unitList[0] || "",
          };
        }
        return acc;
      },
      {}
    );

    // Initialize other parameters from _items.other_parameters
    const initialOtherParams = (_items?.other_parameters || []).reduce(
      (acc, param) => {
        acc[param.name] = { value: param.value || "", unit: param.unit || "" };
        return acc;
      },
      {}
    );

    setFormData((prev) => ({
      ...prev,
      parameters: initialParameters,
      otherParams: initialOtherParams,
    }));

    // if (parsedData && _items?.id) {
    VIEW_IGG_LOGBOOK_API(_items.id);
    // }
  }, [_items?.id]);

  // Handle date/time change
  const onChangeDateTime = (value) => {
    setFormData((prev) => ({
      ...prev,
      logDate: value ? value.format("YYYY-MM-DD HH:mm:ss") : null,
    }));
  };

  // Handle parameter value/unit change
  const updateParameter = (param, field, value) => {
    setFormData((prev) => ({
      ...prev,
      parameters: {
        ...prev.parameters,
        [param]: { ...prev.parameters[param], [field]: value },
      },
    }));
  };

  // Handle other parameter value/unit change
  const updateOtherParam = (name, field, value) => {
    setFormData((prev) => ({
      ...prev,
      otherParams: {
        ...prev.otherParams,
        [name]: { ...prev.otherParams[name], [field]: value },
      },
    }));
  };

  // API to view logbook details
  const VIEW_IGG_LOGBOOK_API = async (bwt_id, staff_dashboard) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("bwt_id", bwt_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      // FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      post(ApiURL.edit_view_cargo_bwt_machinery_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const bwtData = res?.response_data;
          setUpdateStatus(bwtData?.complete_status || false);
          // setSubmitStatus(bwtData?.submit_status || false);
          setSubmitStatus(true);

          setChecked(bwtData?.bwt_on_off || false);

          const parameters = Object.keys(
            bwtData?.selected_parameters || {}
          ).reduce((acc, param) => {
            const paramData = bwtData.selected_parameters[param] || {
              value: 0,
              unit: "",
            };
            acc[param] = {
              value:
                paramData.value !== undefined
                  ? paramData.value.toString()
                  : "0",
              unit: paramData.unit || parameterConfig[param]?.unitList[0] || "",
            };
            return acc;
          }, {});

          setFormData((prev) => {
            return {
              ...prev,
              logDate:
                bwtData?.date_time_log ||
                moment().format("YYYY-MM-DD HH:mm:ss"),
              parameters,

              otherParams:
                bwtData?.other_parameters &&
                Object.keys(bwtData.other_parameters).length
                  ? Object.keys(bwtData.other_parameters).reduce((acc, key) => {
                      const paramData = bwtData.other_parameters[key] || {
                        value: "",
                        unit: "",
                      };
                      acc[key] = {
                        value:
                          paramData.value !== undefined
                            ? paramData.value.toString()
                            : "",
                        unit: paramData.unit || "",
                      };
                      return acc;
                    }, {})
                  : prev.otherParams,
            };
          });
        } else {
          setErrors(res?.errors || {});
          ErrorToast("Error", "Failed to fetch logbook details.");
        }
      });
    } catch (error) {
      ErrorToast("Error", "An error occurred while fetching logbook details.");
    }
  };

  // Render
  return (
    <>
      <div className="row custom-box">
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinery Type: {_items?.machinery_type}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            BWT Model: {_items?.BWT_model}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            BWT Maker: {_items?.BWT_maker}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            BWT id: {_items?.id}
          </b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            // onChange={(value) => {
            //   setChecked(value);
            //   updateStatus
            //     ? UPDATE_IGG_LOGBOOK_API(_items?.id, "0", value)
            //     : ADD_IGG_LOGBOOK_API(_items?.id, value);
            // }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {/* Date & Time */}
          <div className="row">
            <div className="col-4">
              <div className="input-box">
                <label>Date & Time</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="Select Date & Time"
                  value={
                    formData.logDate
                      ? moment(formData.logDate, "YYYY-MM-DD HH:mm:ss")
                      : null
                  }
                  onChange={onChangeDateTime}
                  style={{ width: "100%" }}
                  disabled={submitStatus}
                  className="custom-input"
                />
                {errors.date_time_log && (
                  <p className="error-text">{errors.date_time_log}</p>
                )}
              </div>
            </div>
          </div>

          {/* Selected Parameters */}
          {(() => {
            const rows = [];
            const inputs = (_items?.selected_parameters || [])
              .filter((param) => parameterConfig[param])
              .map((param) => ({
                type: "selectedParam",
                name: param,
                config: parameterConfig[param],
                value: formData.parameters[param]?.value || "",
                unit: formData.parameters[param]?.unit || "",
              }));

            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`param-row-${i}`}>
                  {group.map((input) => (
                    <div className="col-4" key={input.name}>
                      {input.config.dropdownOptions ? (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Select
                            disabled={submitStatus}
                            value={input.value}
                            onChange={(value) =>
                              updateParameter(input.name, "value", value)
                            }
                            className="custom-input"
                            style={{ width: "100%" }}
                            placeholder={`Select ${input.config.label}`}
                          >
                            {input.config.dropdownOptions.map((option) => (
                              <Select.Option key={option} value={option}>
                                {option}
                              </Select.Option>
                            ))}
                          </Select>
                          {errors[
                            `pr_${input.name
                              .replace(/([A-Z])/g, "_$1")
                              .toLowerCase()}`
                          ] && (
                            <p className="error-text">
                              {
                                errors[
                                  `pr_${input.name
                                    .replace(/([A-Z])/g, "_$1")
                                    .toLowerCase()}`
                                ]
                              }
                            </p>
                          )}
                        </div>
                      ) : input.config.unitList?.length ? (
                        <UnitWithInput
                          label={input.config.label}
                          value={input.value}
                          onChange={(e) =>
                            updateParameter(input.name, "value", e.target.value)
                          }
                          unit={input.unit}
                          onUnitChange={(e) =>
                            updateParameter(input.name, "unit", e.target.value)
                          }
                          disabled={submitStatus}
                          error={
                            errors[
                              `pr_${input.name
                                .replace(/([A-Z])/g, "_$1")
                                .toLowerCase()}`
                            ]
                          }
                          unitList={input.config.unitList}
                          className="custom-input"
                        />
                      ) : (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Input
                            disabled={submitStatus}
                            value={input.value}
                            placeholder={input.config.label}
                            onChange={(e) =>
                              updateParameter(
                                input.name,
                                "value",
                                e.target.value
                              )
                            }
                            className={`custom-input ${
                              errors[
                                `pr_${input.name
                                  .replace(/([A-Z])/g, "_$1")
                                  .toLowerCase()}`
                              ]
                                ? "error"
                                : ""
                            }`}
                          />
                          {errors[
                            `pr_${input.name
                              .replace(/([A-Z])/g, "_$1")
                              .toLowerCase()}`
                          ] && (
                            <p className="error-text">
                              {
                                errors[
                                  `pr_${input.name
                                    .replace(/([A-Z])/g, "_$1")
                                    .toLowerCase()}`
                                ]
                              }
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-param-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          {/* Other Parameters */}
          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(formData.otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) =>
                          updateOtherParam(name, "value", e.target.value)
                        }
                        unit={unit}
                        onUnitChange={(e) =>
                          updateOtherParam(name, "unit", e.target.value)
                        }
                        disabled={submitStatus}
                        unitList={[unit]} // No specific unit list for other parameters
                        className="custom-input"
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div
                        className="col-4"
                        key={`empty-other-${i}-${idx}`}
                      ></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}
        </>
      )}
    </>
  );
};
